<template>
	<div class="troopOverviewTooltip">
		<h3>
			<span>{{movements.length}}&nbsp;</span>
			<span v-if="type == 'attack' && direction == 'incoming'">Приближающиеся атаки</span>
			<span v-if="type == 'merchant' && direction == 'incoming'">Приближающиеся торговцы</span>
			<span v-if="type == 'merchant_return' && direction == 'incoming'">Возвращающиеся торговцы</span>
			<span v-if="type == 'merchant2' && direction == 'incoming'">Награда за краденые ценности</span>
			<span v-if="type == 'return' && direction == 'incoming'">Возвращающиеся войска</span>
			<span v-if="type == 'support' && direction == 'incoming'">Прибывающие подкрепления</span>
			<span v-if="type == 'defend' && direction == 'incoming'">xxx</span>
			<span v-if="type == 'heal' && direction == 'incoming'">Возвращающиеся исцеленные войска</span>
			<span v-if="type == 'tribute' && direction == 'incoming'">xxx</span>
			<span v-if="type == 'wounded' && direction == 'incoming'">Возвращающиеся раненые войска</span>
			
			<span v-if="type == 'defend' && direction == 'outgoing'">xxx</span>
			<span v-if="type == 'heal' && direction == 'outgoing'">xxx</span>
			<span v-if="type == 'tribute' && direction == 'outgoing'">xxx</span>
			<span v-if="type == 'adventure' && direction == 'outgoing'">Приключение</span>
			<span v-if="type == 'attack' && direction == 'outgoing'">Исходящие атаки</span>
			<span v-if="type == 'raid' && direction == 'outgoing'">Исходящие атаки (набег)</span>
			<span v-if="type == 'spy' && direction == 'outgoing'">Исходящие атаки (разведка)</span>
			<span v-if="type == 'support' && direction == 'outgoing'">Исходящие подкрепления</span>
			<span v-if="type == 'merchant' && direction == 'outgoing'">Отправленные торговцы</span>
			<span v-if="type == 'settle' && direction == 'outgoing'">Основание новой деревни</span>
		</h3>
		<div v-if="type == 'heal' && direction == 'incoming'">
			<span>Исцелено при помощи </span>
			<i class="icon movement_heal_small_flat_black"></i>
		</div>
		<span v-for="movement in sortedMovements" :key="movement.id">
			<div class="horizontalLine"></div>
			<div v-if="(type == 'attack' || type == 'return' || type == 'merchant_return') && direction == 'incoming'">
				<table class="transparent">
					<tbody>
						<tr>
							<th colspan="2">
								<span>Из:</span>
							</th>
							<td>{{movement.srcIsland}}</td>
						</tr>
						<tr class="village">
							<th>
								<span>Через:</span>
							</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<display-resources
					v-if="type == 'merchant_return'"
					:resources="movement.resources"
					:show-as-old-resources="true"
					:game-model="gameModel"
				/>
			</div>
			<div v-if="(type == 'merchant' || type == 'merchant2') && direction == 'incoming'">
				<table class="transparent">
					<tbody>
						<tr>
							<th>{{movement.srcPlayer}}</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.srcIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<display-resources
					:resources="movement.resources"
					:game-model="gameModel"
				/>
			</div>
			<div v-if="type == 'support' && direction == 'incoming'">
				<table class="transparent">
					<tbody>
						<tr>
							<th>{{movement.srcPlayer}}</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.srcIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="(type == 'defend' || type == 'tribute') && direction == 'incoming'">
				xxx
			</div>
			<div v-if="(type == 'heal' || type == 'wounded') && direction == 'incoming'">
				<table class="transparent">
					<tbody>
						<tr>
							<th>{{movement.destPlayer}}</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.srcIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
			<div v-if="(type == 'defend' || type == 'tribute' || type == 'heal') && direction == 'outgoing'">
				xxx
			</div>
			<div v-if="type == 'adventure' && direction == 'outgoing'">
				<table class="transparent">
					<tbody>
						<tr>
							<th></th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>Приключение</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="(type == 'attack' || type == 'raid' || type == 'spy' || type == 'support') && direction == 'outgoing'">
				<table class="transparent">
					<tbody>
						<tr>
							<th>{{movement.destPlayer}}</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.destIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="type == 'merchant' && direction == 'outgoing'">
				<table class="transparent">
					<tbody>
						<tr>
							<th>{{movement.destPlayer}}</th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.destIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<display-resources
					:resources="movement.resources"
					:game-model="gameModel"
				/>
			</div>
			<div v-if="type == 'settle' && direction == 'outgoing'">
				<table class="transparent">
					<tbody>
						<tr>
							<th></th>
							<td>
								<span>
									<vue-countdown :time="movement.time * 1000" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</span>
							</td>
						</tr>
						<tr class="village">
							<th>{{movement.destIsland}}</th>
							<td>
								<span>{{formatUnixDate(movement.timeFinish, 'HH:mm:ss')}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</span>
	</div>
</template>

<style lang="scss" scoped>
	
</style>

<script>
import lib from '@/lib';
import VueCountdown from '@chenfengyuan/vue-countdown';
import DisplayResources from '@/components/elements/DisplayResources';

export default {
	props: {
		type: {
			type: String,
			required: true,
		},
		direction: {
			type: String, // incoming, outgoing
			required: true,
		},
		movements: {
			type: Array,
			default: () => [],
		},
		gameModel: {
			type: Object,
			required: true,
		},
	},
	computed: {
		sortedMovements() {
			return this.movements.sort((a, b) => a.timeFinish - b.timeFinish);
		},
	},
	methods: {
		formatUnixDate: lib.formatUnixDate,
	},
	components: {
		VueCountdown,
		DisplayResources,
	},
}
</script>